export interface IGoogleSearchAddress {
  formattedAddress: string;
  addressLine1: string;
  addressLine2: string;
  zipCode: string;
  country?: string;
  state: string;
  stateShortName: string;
  city: string;
  lat?: string;
  long?: string;
}
